import './form-content.scss';

import * as gzFormContent from './form-content.directive';

export default angular.module('gazelle.components.formContent', [
])
  .directive(gzFormContent.name, gzFormContent.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/form-content/form-content.module.js